import React, { Component } from "react";
import {
    Row,
    Col,
    Button
} from "reactstrap";

import Registry from "../../Utils/Registry";
import Helpers from "../../Utils/Helpers";


class CreateOrderRecap extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.toggleCGV = this.toggleCGV.bind(this);
        this.toggleVehicles = this.toggleVehicles.bind(this);
        this.validateOrder = this.validateOrder.bind(this);

        this.state = {
            showVehicles: false,
            cgv_toggled: false
        }
    }

    toggleCGV(){
        this.setState({cgv_toggled: !this.state.cgv_toggled});
    }

    toggleVehicles(){
        this.setState({showVehicles: !this.state.showVehicles});
    }

    validateOrder(){
        this.props.onValidateOrder();
    }

    render(){
        let paiment_block = <Col md={this.props.step < 3 ? 12 : 6}>
                <h4 className="ty-recap-order-cat marg-t-20 marg-b-20">Moyen de paiement</h4>
                {
                    this.props.payment ?
                        <div className="marg-l-15 marg-b-5">
                            { this.props.payment.label }
                        </div>
                        :
                        <div className="gray marg-b-5">Non renseign&eacute;</div>
                }
            </Col>;

        return (
            <div className="pad-t-25">
                <div className="ty-block pad-0-important">
                    <div className="text-uppercase pad-15 pad-t-20 pad-b-20 border-b-1-gray">
                        <h2 className="ty-subtitle marg-0-important">Votre commande</h2>
                    </div>
                    <div className="pad-15 blue_dark">
                        {
                            this.props.showGasPrices ?
                                <div className="border-1-gray marg-t-5 pad-10 rounded">
                                    <Row>
                                        <Col lg={this.props.gnv_price !== undefined ? 3 : 6} className="f-12">
                                            Prix moyen des carburants<br />
                                            (en temps r&eacute;el)
                                        </Col>
                                        <Col lg="3" className="f-12 bold right">
                                            <span className="gazole">Gasoil</span>
                                            <div className="thin f-12">{ this.props.gazole_price } &euro;/L TTC</div>
                                        </Col>
                                        <Col lg="3" className="f-12 bold right">
                                            <span className="sp95">SP 98</span>
                                            <div className="thin f-12">{ this.props.sp_price } &euro;/L TTC</div>
                                        </Col>
                                        {
                                            this.props.gnv_price !== undefined ?
                                                <Col lg="3" className="f-12 bold right">
                                                    <span className="gnv">GNV</span>
                                                    <div className="thin f-12">{ this.props.gnv_price } &euro;/Kg TTC</div>
                                                </Col>
                                                : undefined
                                        }
                                    </Row>
                                    <Row className="marg-t-10">
                                        <Col lg="8" className="f-12">
                                            Frais de livraison
                                        </Col>
                                        <Col lg="4" className="f-12 right">
                                            { this.props.fee_per_vehicle } &euro; TTC
                                            { this.props.fees_type === 0 ? '/véhicule' : '' }
                                        </Col>
                                    </Row>
                                </div>
                                :
                                <div className="border-1-gray marg-t-5 pad-10 rounded">
                                    Pour visualiser les tarifs des carburants du jour, s&eacute;lectionnez une adresse de livraison.
                                </div>
                        }


                        <Row>
                            <Col lg="12">
                                <h4 className="ty-recap-order-cat marg-t-20 marg-b-20">Information de livraison</h4>
                                {
                                    this.props.deliverySlot ?
                                        <div className="marg-l-15 marg-b-5">
                                            { this.props.location }<br />
                                            {Helpers.formatDate(this.props.deliverySlot.date, "dddd DD MMMM")}
                                            &nbsp;de { Helpers.formatNumber(this.props.deliverySlot.min, "00") }h 
                                            &agrave; { this.props.deliverySlot.max === 24 ? "00" : Helpers.formatNumber(this.props.deliverySlot.max, "00") }h
                                        </div>
                                        :
                                        <div className="gray marg-b-5">Non renseign&eacute;</div>
                                }
                            </Col>
                        </Row>

                        <Row>
                            <Col md={this.props.step < 3 ? 12 : 6}>
                                <h4 className="ty-recap-order-cat marg-t-20 marg-b-20 pointer" onClick={this.toggleVehicles}>
                                    V&eacute;hicules
                                    {
                                        this.props.vehicles.length ?
                                            <span>
                                                &nbsp;({this.props.vehicles.length}) <i className={"icon icon-chevron-" + (this.state.showVehicles ? "up" : "down") + " marg-l-15"}> </i>
                                            </span>
                                            :
                                            null
                                    }
                                </h4>
                                {
                                    this.props.vehicles.length ?
                                        this.state.showVehicles ?
                                            <ul className="list-unstyled marg-l-15 marg-b-5">
                                                {
                                                    this.props.vehicles.map((vehicle, i) => {
                                                        return <li key={i} className={"pad-l-5 marg-b-5"} style={{
															borderLeftColor: vehicle.gas_color,
															borderLeftWidth: 5
														}}
                                                        >
                                                            { vehicle.description + " " + vehicle.color }  &nbsp;
                                                            { vehicle.plate }
                                                        </li>;
                                                    })
                                                }
                                            </ul>
                                            :
                                            null
                                        :
                                        <div className="gray marg-b-5">Non renseign&eacute;</div>
                                }
                            </Col>

                            { this.props.step < 3 ? null : paiment_block }
                        </Row>

                        { this.props.step < 3 ? <Row> {paiment_block} </Row> : null }
                    </div>
                </div>

                {
                    this.props.step === 3 ?
                        <div className="marg-t-20">
                            <div className="marg-b-10">
                                <input type="checkbox" className="ty-checkbox" id="cgv" onChange={this.toggleCGV} />
                                <label htmlFor="cgv" className="f-13 blue_dark">
                                    J'ai lu et j'accepte les <a target="_blank" href={"https://tankyou-cdn.s3.eu-west-2.amazonaws.com/public/Documents/cgu.pdf"} className="primary_link">conditions g&eacute;n&eacute;rales de vente</a>
                                </label>
                            </div>

                            <div className="center marg-t-20">
                                <Button
                                    className="text-uppercase"
                                    color="primary"
                                    disabled={!this.state.cgv_toggled}
                                    onClick={this.validateOrder}
                                >
                                    Valider la commande
                                </Button>
                            </div>
                        </div>
                        :
                        ""
                }
            </div>
        );
    }
}

CreateOrderRecap.defaultProps = {
    sp_price: 0,
    gazole_price: 0,
    gnv_price: undefined,
    fee_per_vehicle: 0,
    fees_type: 0,
    deliverySlot: null,
    location: null,
    vehicles: [],
    payment: null,
    step: 0,
    showGasPrices: false,
    onValidateOrder: () => {}
};

export default CreateOrderRecap;



// WEBPACK FOOTER //
// ./src/components/CreateOrder/Recap.js